module.exports = __webpack_public_path__ + "img/category-management-icon6.005ba646.svg";